// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

let arrDomain = ["be", "tasetco", "pcspost", "vintrans", "airlineexpress", "shipnhanh", "vietstarexpress", "guihangvevietnam",
  "bbdeliv", "chuyenphatnhanh", "dsc", "gsdp", "giaohangbienhoa","veep", "flashship","hoangduc"];
let hostname = location.hostname.split(".");
let domain = "gsdp";

// domains name
const DOMAIN_TASETCO: string = "tasetco";
const DOMAIN_PCS: string = "pcspost";
const DOMAIN_VINTRANS: string = "vintrans";
const DOMAIN_AIRLINE: string = "airlineexpress";
const DOMAIN_VIETSTAREXPRESS: string = "vietstarexpress";
const DOMAIN_FLASHSHIP: string = "flashship";
const DOMAIN_BBDELIV: string = "bbdeliv";
const DOMAIN_DELTA: string = "chuyenphatnhanh";
const DOMAIN_DSC: string = "dsc";
const DOMAIN_GSDP: string = "gsdp";
const DOMAIN_BE: string = "be";
const DOMAIN_BE_STAGE: string = "veep";
const DOMAIN_GHBH: string = "giaohangbienhoa";
const DOMAIN_HOANGDUC: string = "hoangduc";

var envir = {
  production: false,
  company: "GSDP",
  title: "GSDP",
  name: "GSDP",

  gMapKey: "AIzaSyBu4Y90CByGCKL5rxjR1bfCPAKVkh5KhYA",
  tokenFirebase: "AIzaSyAY9k6gMHd_wx-IiLyhzzYdKh_xhpOxKeM_DEFAULT",
  urlFirebase: "https://fcm.googleapis.com/fcm/send",

  urlLogo: "",
  apiGeneralUrl: "",
  apiCRMUrl: "",
  apiPostUrl: "",
  apiCusUrl: "",

  hub: {
    centerHubLongName: "",
    centerHubSortName: "",
    poHubLongName: "",
    poHubSortName: "",
    stationHubLongName: "",
    stationHubSortName: "",
  }
};
//domain
envir = getEnvironment(domain);

function getEnvironment(domainName: string) {
  switch (domainName) {
    // DEFAULT
    default:
      envir.gMapKey = "AIzaSyCkR-wl8rYwyb5XhvinbcfZOuFsRV2IFDo";
      envir.urlLogo = "/assets/images/logo/gsdp.png";
      // envir.apiCRMUrl =     'https://crmapitest.gsdp.vn/api';
      // envir.apiCusUrl =     'https://cusapitest.gsdp.vn/api';
      // envir.apiGeneralUrl = 'https://coreapitest.gsdp.vn/api';
      // envir.apiPostUrl =    'https://postapitest.gsdp.vn/api';

      envir.apiCRMUrl =     'https://crmapi.gsdp.vn/api';
      envir.apiCusUrl =     'https://cusapi.gsdp.vn/api';
      envir.apiGeneralUrl = 'https://coreapi.gsdp.vn/api';
      envir.apiPostUrl =    'https://postapi.gsdp.vn/api';
      
      // envir.apiCRMUrl =     'http://localhost:55409/api';
      
      
      
      envir.hub.centerHubLongName = "Trung tâm";
      envir.hub.centerHubSortName = "TT";
      envir.hub.poHubLongName = "Chi nhánh";
      envir.hub.poHubSortName = "CN";
      envir.hub.stationHubLongName = "Bưu cục";
      envir.hub.stationHubSortName = "BC"
      break;
  }
  return envir;
}

export const environment = envir;


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/environments/environment.ts